import { selectActiveWorkout, selectYogaType } from 'store/personalPlan/selectors';

import { useSelector } from '../store';

export const useGetPPCommonAnalyticsData = () => {
    const activeWorkout = useSelector(selectActiveWorkout);
    const yogaType = useSelector(selectYogaType);

    if (!activeWorkout) return;

    const { focus, focus_zones, level, day_number } = activeWorkout;

    return {
        plan_day: day_number,
        focus,
        focus_zones,
        exercise_level: level,
        yoga_type: yogaType,
        exercise_source: 'plan',
    };
};
